import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext, useMemo } from 'react';
import DataCacheService from '@/shared/services/DataCacheService';
import AuthService from '../services/AuthService';
export const DataContext = React.createContext(null);
export const useDataContext = () => {
    const ctx = useContext(DataContext);
    if (!ctx) {
        throw new Error('Wrap app with DataProvider');
    }
    return ctx;
};
const DataProvider = ({ children }) => {
    const getUsers = useMemo(() => DataCacheService.getUsers(), []);
    const getDefaultCompany = useMemo(() => DataCacheService.getDefaultCompany(), []);
    const getCurrentUserId = useMemo(() => AuthService.getUserId(), []);
    const getUserLanguage = useMemo(() => DataCacheService.getUserLanguage(getCurrentUserId), [
        getCurrentUserId,
    ]);
    const getCompanies = useMemo(() => DataCacheService.getCompanies(), []);
    const getAllCompanies = useMemo(() => DataCacheService.getAllCompanies(), []);
    const value = useMemo(() => ({
        users: getUsers,
        defaultCompany: getDefaultCompany,
        currentUserId: getCurrentUserId,
        userLanguage: getUserLanguage,
        companies: getCompanies,
        allCompanies: getAllCompanies,
    }), [getDefaultCompany, getUsers, getCurrentUserId, getUserLanguage, getCompanies, getAllCompanies]);
    return _jsx(DataContext.Provider, Object.assign({ value: value }, { children: children }));
};
export default DataProvider;
